import { render, staticRenderFns } from "./TableLivraisons.vue?vue&type=template&id=7ca1560c&"
import script from "./TableLivraisons.vue?vue&type=script&lang=js&"
export * from "./TableLivraisons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports